import { createSelector } from "reselect";
import { State } from "../state";
import { buildFormattedAuditEntityLog } from "./formattedAuditLog";
import { AUDIT_LOG_STATES } from "./reducer";
import { HistoryAuditLogs } from "./types";

const getAuditLogState = (state: State) => state.auditLog;

export const getAuditLogLoaded = createSelector(
  getAuditLogState,
  auditLog =>
    Boolean(auditLog.auditLog) || auditLog.status === AUDIT_LOG_STATES.LOADED
);

export const getAuditLogError = createSelector(
  getAuditLogState,
  auditLog => auditLog.status === AUDIT_LOG_STATES.ERROR
);

export const getAuditLog = createSelector(
  getAuditLogState,
  auditLog => (auditLog.auditLog ? auditLog.auditLog : {})
);

export const getFormattedAuditLog = createSelector(
  getAuditLog,
  buildFormattedAuditEntityLog
);

export const getHistoryAuditLog = createSelector(
  getAuditLogState,
  auditLog =>
    auditLog.status === AUDIT_LOG_STATES.LOADED
      ? (auditLog.auditLog as HistoryAuditLogs)
      : ([] as HistoryAuditLogs)
);

export const getFormattedHistoryAuditLog = createSelector(
  getHistoryAuditLog,
  buildFormattedAuditEntityLog
);



// WEBPACK FOOTER //
// ./src/auditLog/selector.ts